import { Amplify } from 'aws-amplify';

const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID,
      signUpVerificationMethod: 'code',
      loginWith: {
        oauth: {
          domain: process.env.REACT_APP_COGNITO_DOMAIN,
          scopes: ['openid', 'email'],
          redirectSignIn: [process.env.REACT_APP_REDIRECT_SIGN_IN],
          redirectSignOut: [process.env.REACT_APP_REDIRECT_SIGN_OUT],
          responseType: 'code',
          providers: ['Google']
        }
      }
    }
  }
};

// Log configuration for debugging (remove in production)
console.log('Amplify Config:', {
  userPoolId: process.env.REACT_APP_USER_POOL_ID,
  userPoolClientId: process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID,
  domain: process.env.REACT_APP_COGNITO_DOMAIN,
  redirectSignIn: [process.env.REACT_APP_REDIRECT_SIGN_IN],
  redirectSignOut: [process.env.REACT_APP_REDIRECT_SIGN_OUT]
});

// Additional debug logging for OAuth configuration
console.log('OAuth Configuration:', {
  hasRedirectSignIn: !!process.env.REACT_APP_REDIRECT_SIGN_IN,
  redirectSignInValue: process.env.REACT_APP_REDIRECT_SIGN_IN,
  hasRedirectSignOut: !!process.env.REACT_APP_REDIRECT_SIGN_OUT,
  redirectSignOutValue: process.env.REACT_APP_REDIRECT_SIGN_OUT,
  scopes: ['openid', 'email']
});

Amplify.configure(amplifyConfig);

export default amplifyConfig; 